import axios from "axios";
import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export const AuthContexProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(
    JSON.parse(localStorage.getItem("user")) || { user: "claire" }
  );

  const login = async (userInputs) => {
    await axios
      .post("http://localhost:8080/login", userInputs, {
        withCredentials: true,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Credentials": "true",
        },
      })
      .then((response) => {
        console.log(response);
        setCurrentUser(response.data);
      });
  };

  const logout = async () => {
    await axios.post("http://localhost:8080/logout");
    setCurrentUser(null);
  };

  //update local storage with user data
  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(currentUser));
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
